import * as TimersUtils from './timers';

export default TimersUtils;
